import { useMutation, useQueryClient } from "react-query";
import { updateAction } from "client-api-workflow";

export interface UpdateActionParams {
	actionName?: string;
	description?: string;
	assignTo?: string[];
	assignToNames?: string[];
	searchKpiInitiativeId?: string | null;
	searchKpiInitiativeName?: string | null;
	searchKpiInitiativeType?: string | null;
	status?: string;
}

const useUpdateAction = () => {
	const queryClient = useQueryClient();

	return useMutation(
		async ({ id, data }: { id: string; data: UpdateActionParams }) => {
			const result = await updateAction(id, data);
			return result;
		},
		{
			onSuccess: (_, variables) => {
				// Invalidate the specific action query
				queryClient.invalidateQueries({
					queryKey: ["action", variables.id],
				});
				// Invalidate the actions list query to refresh the list
				queryClient.invalidateQueries({
					predicate: (query) => query.queryKey.indexOf("actions") >= 0,
				});
			},
		}
	);
};

export default useUpdateAction;

